module.exports = __webpack_public_path__ + "img/2300-2_YR_2022_WirelessConnection.5f7b2e14.png";